<ng-container
  *matRowDef="let row; columns: [columnName]; when: isExpansionDetailRow"
>
  <tr
    mat-row
    class="detail-row"
    [class.expanded-details]="isElementExpanded(row.element)"
    [@detailExpand]="isElementExpanded(row.element) ? 'expanded' : 'collapsed'"
  ></tr>
</ng-container>

<ng-container [matColumnDef]="columnName">
  <ng-container
    *matCellDef="let row"
  >
    <ng-template
      [ngTemplateOutlet]="templateRef"
      [ngTemplateOutletContext]="{$implicit: row.element}"
    ></ng-template>
  </ng-container>
</ng-container>
